export default "__VITE_ASSET__D3$B216m__"